// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4c10b482","453":"c445203e","876":"a0a1973a"}[chunkId] + ".chunk.js";
};